import { useQueryClient } from 'react-query';
import { useCallback } from 'react';
import { getKey as getInReviewSearchCountKey } from './useInReviewSearchCount';
import { getKey as getArchivedSearchCountKey } from './useArchivedSearchCount';
import { getKey as getMyACtiveSearchesCountKey } from './useMyActiveSearchesCount';

export function useInvalidateSearchCounts() {
  const queryClient = useQueryClient();
  return useCallback(() => {
    queryClient.invalidateQueries(getInReviewSearchCountKey());
    queryClient.invalidateQueries(getArchivedSearchCountKey());
    queryClient.invalidateQueries(getMyACtiveSearchesCountKey());
  }, []);
}
